(() => {
  const modal = document.getElementById('zoomModal');
  if (!modal) return;

  const img = document.getElementById('zoomImg');
  const closeBtn = modal.querySelector('.zoom-close');
  const prevBtn = modal.querySelector('.zoom-prev');
  const nextBtn = modal.querySelector('.zoom-next');
  const idxEl = document.getElementById('zoomIndex');
  const totalEl = document.getElementById('zoomTotal');

  // Collect all zoomable images (desktop intent)
  const zoomNodes = Array.from(document.querySelectorAll(
    '.js-zoomable-grid, .js-zoomable-main, .js-zoomable-thumb, .pd-media-grid__item img'
  )).filter(n => n.dataset.zoomSrc ?? n.src
  );

  // Sort by index so prev/next is consistent
  zoomNodes.sort((a,b) => (+a.dataset.zoomIndex || 0) - (+b.dataset.zoomIndex || 0));

  if (!zoomNodes.length) return;

  let current = 0;
  let zoomed = false;
const scale = 2.4;     // zoom factor
const DAMP  = 0.65;    // 0.4–0.75 feels nice

  const openAt = (i) => {
    current = (i + zoomNodes.length) % zoomNodes.length;
    img.src = zoomNodes[current].dataset.zoomSrc ?? zoomNodes[current].src;
    idxEl && (idxEl.textContent = String(current + 1));
    totalEl && (totalEl.textContent = String(zoomNodes.length));
    img.style.transform = 'translate3d(0,0,0) scale(1)';
    img.classList.remove('is-zoomed');
    zoomed = false;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
  };

  const close = () => {
    modal.setAttribute('hidden','');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
  };

  const nav = (dir) => openAt(current + dir);

  // Only open on desktop
  const desktop = () => window.matchMedia('(pointer:fine) and (min-width: 1024px)').matches;

  zoomNodes.forEach((n) => {
    n.addEventListener('click', (e) => {
      if (!desktop()) return;
      e.preventDefault();
      openAt(parseInt(n.dataset.zoomIndex || '0', 10));
    });
  });

  closeBtn?.addEventListener('click', close);
  prevBtn?.addEventListener('click', () => nav(-1));
  nextBtn?.addEventListener('click', () => nav(1));

  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

  window.addEventListener('keydown', (e) => {
    if (modal.hasAttribute('hidden')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') nav(-1);
    if (e.key === 'ArrowRight') nav(1);
  });

  // Zoom/pan
  // tweakables

    const setTransformFromMouse = (evt) => {
      return true;
        const box = img.getBoundingClientRect();

        // mouse position in [0..1]
        const x = (evt.clientX - box.left) / box.width;
        const y = (evt.clientY - box.top)  / box.height;

        // total extra pixels available when scaled
        const overflowX = box.width  * (scale - 1);
        const overflowY = box.height * (scale - 1);

        // translate so the point under the cursor stays near center
        let tx = (0.5 - x) * overflowX * DAMP;
        let ty = (0.5 - y) * overflowY * DAMP;

        // clamp so it never pushes past the edges
        const maxX = overflowX / 2;
        const maxY = overflowY / 2;
        tx = Math.max(-maxX, Math.min(maxX, tx));
        ty = Math.max(-maxY, Math.min(maxY, ty));

        img.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${scale})`;
    };


  img.addEventListener('click', (e) => {
    if (!desktop()) return;
    zoomed = !zoomed;
    if (zoomed) {
      img.classList.add('is-zoomed');
      setTransformFromMouse(e);
    } else {
      img.classList.remove('is-zoomed');
      img.style.transform = 'translate3d(0,0,0) scale(1)';
    }
  });

  img.addEventListener('mousemove', (e) => { if (zoomed) setTransformFromMouse(e); });
  img.addEventListener('dragstart', (e) => e.preventDefault());
})();
